module Meevo.Components.GlobalNav {

    export class MeevoGlobalNavTopRow implements ng.IDirective {
        restrict = "E";
        templateUrl = "app/components/globalNav/globalNavTopRow.template.html";
        scope = false;

        static factory(): angular.IDirectiveFactory {
            const directive = () => {
                return new MeevoGlobalNavTopRow();
            };

            return directive;
        }
    }

    angular.module("meevo.components.globalNav")
        .directive("meevoGlobalNavTopRow", MeevoGlobalNavTopRow.factory());
}